import { BASE_JWT_URL } from 'constants/environmentVariables';
import axiosInstance from 'services/axiosConfig';
import { handleErrors } from 'actions/errors';
import { createSubmitEvent, logEvent, updateSubmitEvent } from 'services/firebaseLogger';
import { addSnackbarAlerts, setBatteryMakes, setBatteryModels } from 'reducers/globalSlice';
import { setManageDrawer } from 'reducers/manageTablesSlice';
import { currentAccountIdSelector } from 'reducers/userAuthSlice';
import { t } from 'i18next';

export const fetchBatteryDetails = battery_id => async (dispatch, getState) => {
	const currentAccountId = currentAccountIdSelector(getState());
	const url = `${BASE_JWT_URL}/v1/account/${currentAccountId}/batteries/${battery_id}?appends[]=flight_time_30_days&appends[]=total_flight_time&appends[]=flight_30_days&appends[]=total_flights&appends[]=health&appends[]=tags`;
	try {
		const response = await axiosInstance.get(url);
		dispatch(
			setManageDrawer({
				data: response.data.data
			})
		);
		return response.data.data;
	} catch (error) {
		handleErrors({ errors: error, dispatch });
	}
};

export const updateBatteryDetails = (battery_id, payload) => async (dispatch, getState) => {
	const currentAccountId = currentAccountIdSelector(getState());
	const url = `${BASE_JWT_URL}/v1/account/${currentAccountId}/batteries/${battery_id}`;
	try {
		const response = await axiosInstance.put(url, payload);
		dispatch(
			setManageDrawer({
				data: response.data.data
			})
		);
		logEvent(updateSubmitEvent('battery'));
		return response;
	} catch (error) {
		handleErrors({ errors: error, dispatch });
	}
};

export const postNewBattery = payload => async (dispatch, getState) => {
	const currentAccountId = currentAccountIdSelector(getState());
	const url = `${BASE_JWT_URL}/v1/account/${currentAccountId}/batteries`;
	try {
		const response = await axiosInstance.post(url, payload);
		dispatch(
			addSnackbarAlerts([
				{
					type: 'success',
					message: t('Battery Successfully Added')
				}
			])
		);
		logEvent(createSubmitEvent('battery'));
		return response.data.data;
	} catch (error) {
		handleErrors({ errors: error, dispatch });
	}
};

export const getBatteryModels = () => async dispatch => {
	const url = `${BASE_JWT_URL}/v1/batteries/models`;
	try {
		const response = await axiosInstance.get(url);
		const list = response.data.data;
		const formattedList = list.map(item => {
			return {
				value: item.name,
				label: item.name
			};
		});
		dispatch(setBatteryModels(formattedList));
		return response.data.data;
	} catch (error) {
		handleErrors({ errors: error, dispatch });
	}
};

export const getBatteryMakes = () => async dispatch => {
	const url = `${BASE_JWT_URL}/v1/batteries/manufacturers`;
	try {
		const response = await axiosInstance.get(url);
		const list = response.data.data;
		const formattedList = list.map(item => {
			return {
				value: item.name,
				label: item.name
			};
		});
		dispatch(setBatteryMakes(formattedList));
		return response.data.data;
	} catch (error) {
		handleErrors({ errors: error, dispatch });
	}
};
